class MeterSubmission {
    /**
     * @param {jQuery} $
     * @param {Boolean} qrcode
     */
    static init($, qrcode) {
        this._$     = $;
        this.qrcode = qrcode;

        this._$(document).ajaxComplete((event, jqXHR, ajaxOptions) => console.log(JSON.parse(jqXHR.responseText)));

        this._currentTab       = '#info';
        this._loginCheckHandle = undefined;

        this._modal = this._$('#wvll_modal');

        this._tabInfoButton       = this._$('[data-target="#info"]');
        this._tabSubmissionButton = this._$('[data-target="#submission"]');
        this._tabCompleteButton   = this._$('[data-target="#complete"]');

        this._containerInfo        = this._$('#info');
        this._containerSubmmission = this._$('#submission');
        this._containerComplete    = this._$('#complete');
        this._containerError       = this._$('.errorContainer');

        this._buttonLogin    = this._$('button[name=meterLogin]');
        this._buttonContinue = undefined;
        this._buttonSubmit   = undefined;

        this._inputUsername    = this._$('input[name=verbrauchsstelle]');
        this._inputPassword    = this._$('input[name=passwort]');
        this._inputZaehler1    = undefined;
        this._inputZaehler2    = undefined;
        this._inputZaehler3    = undefined;
        this._inputDatum       = undefined;
        this._inputTelefon     = undefined;
        this._inputEMail       = undefined;
        this._inputBemerkungen = undefined;
        this._inputPrivacy     = undefined;
        this._inputAblesekarte = undefined;
        this._inputRechnung    = undefined;
        this._inputKopie       = undefined;

        this._modal.on('shown.bs.modal', () => {
            if (this._currentTab === '#info') {
                this._inputUsername.focus();
            }
        });

        this._bindTabWatcher();
        // this._bindKeyboardListener();
        this._bindLogin();

        if (JSON.parse(this._modal.data('connOpen'))) {
            this._buttonLogin.trigger('click');
            this._modal.modal('show');
        }
    }

    /**
     * @private
     */
    static _startLoginCheck() {
        if (this._loginCheckHandle) {
            return;
        }

        this._loginCheckHandle = setInterval(() => {
            this._$.post('ajax/wvll/ajax.php', {
                action: 'checkLogin'
            }).then(JSON.parse).then(response => {
                if (response.error) {
                    this._loginCheckHandle = clearInterval(this._loginCheckHandle);

                    this._tabInfoButton.tab('show');
                    this._containerError.html(response.response).show();

                    this._containerComplete.html('');
                    this._containerSubmmission.html('');

                    this._tabCompleteButton.addClass('disabled');
                    this._tabSubmissionButton.addClass('disabled');
                }
            })
        }, 5000);
    }

    /**
     * @private
     */
    static _stopLoginCheck() {
        this._loginCheckHandle = clearInterval(this._loginCheckHandle);
    }

    /**
     * @private
     */
    static _bindTabWatcher() {
        this._$('a[data-toggle=tab]')
            .on('show.bs.tab', event => {
                if (event && event.target) {
                    this._$(this._$(event.target).data('target')).find('button').removeAttr('disabled');
                }
            })
            .on('shown.bs.tab', event => {
                if (event) {
                    if (event.target) {
                        this._currentTab = this._$(event.target).data('target');

                        if (this._currentTab === '#submission') {
                            this._inputZaehler1.focus();
                        } else if (this._currentTab === '#complete') {
                            this._inputPrivacy.focus();
                        }
                    }

                    if (event.relatedTarget) {
                        this._$(this._$(event.relatedTarget).data('target')).find('button').attr('disabled', 'disabled');
                    }
                }
            });
    }

    /**
     * @private
     */
    static _bindKeyboardListener() {
        const KEY_ENTER = 13;

        this._$(document).on('keyup', event => {
            if (!this._modal.hasClass('show')) {
                return;
            }

            if (event && event.keyCode && event.keyCode === KEY_ENTER) {
                switch (this._currentTab) {
                    case '#info':
                        if (!this._buttonLogin.prop('disabled')) {
                            this._buttonLogin.trigger('click');
                        }
                        break;
                    case '#submission':
                        if (this._buttonContinue && !this._buttonContinue.prop('disabled')) {
                            this._buttonContinue.trigger('click');
                        }
                        break;
                    case '#complete':
                        if (this._buttonSubmit && !this._buttonSubmit.prop('disabled')) {
                            this._buttonSubmit.trigger('click');
                        }
                        break;
                }
            }
        });
    }

    /**
     * @private
     */
    static _bindLogin() {
        new SingleExecutionHandler(this._buttonLogin, 'click', () => {
            const ident = this._inputUsername.val();
            const pass  = this._inputPassword.val();

            if (!ident.length || !pass.length) {
                return;
            }

            this._inputPassword.val('');

            return this._login(ident, pass);
        });
    }

    /**
     * @private
     */
    static _bindContinue() {
        new SingleExecutionHandler(this._buttonContinue, 'click', async () => {
            const requiredFields = [ 'zaehler1', 'zaehler2', 'zaehler3', 'datum' ];

            const continueExecution = await this._$.post('ajax/wvll/ajax.php', {
                action:      'validateAndSaveSubmissionInput',
                zaehler1:    [ this._inputZaehler1.prop('min'), this._inputZaehler1.val() ],
                zaehler2:    [ this._inputZaehler2.prop('min'), this._inputZaehler2.val() ],
                zaehler3:    [ this._inputZaehler3.prop('min'), this._inputZaehler3.val() ],
                datum:       this._inputDatum.val(),
                tel:         this._inputTelefon.val(),
                email:       this._inputEMail.val(),
                bemerkungen: this._inputBemerkungen.val()
            }).then(JSON.parse).then(response => {
                if (response.error) {
                    this._containerError.html(response.response).show();

                    // client tried to send data a second time
                    if (!response.fields) {
                        this._tabInfoButton.tab('show');
                        return;
                    }

                    for (const name of response.fields) {
                        this._$(`input[name=${name}]`).removeClass('is-valid').addClass('is-invalid');
                    }

                    for (const name of requiredFields.filter(val => !response.fields.includes(val))) {
                        this._$(`input[name=${name}]`).removeClass('is-invalid').addClass('is-valid');
                    }
                } else {
                    if (response.skipSubmission) {
                        this._containerComplete.html(response.response);
                        this._tabCompleteButton.removeClass('disabled').tab('show');

                        this._containerError = this._$('.errorContainer');
                        this._inputPrivacy   = this._$('input[name=datenschutz]');

                        this._startLoginCheck();

                        return false;
                    }

                    this._containerError.hide();

                    for (const name of requiredFields) {
                        this._$(`input[name=${name}]`).removeClass('is-invalid').addClass('is-valid');
                    }
                }

                return !response.error;
            });

            if (!continueExecution) {
                return;
            }

            return this._$.post('ajax/wvll/ajax.php', {
                action: 'complete'
            }).then(JSON.parse).then(response => {
                if (!response.error) {
                    this._containerComplete.html(response.response);
                    this._tabCompleteButton.removeClass('disabled').tab('show');

                    this._containerError = this._$('.errorContainer');
                    this._buttonSubmit   = this._$('button[name=completeSend]');

                    this._inputPrivacy     = this._$('input[name=datenschutz]');
                    this._inputAblesekarte = this._$('input[name=ablesekarte]');
                    this._inputRechnung    = this._$('input[name=rechnung]');
                    this._inputKopie       = this._$('input[name=kopie]');

                    this._startLoginCheck();
                    this._bindSubmit();
                } else {
                    // handled by MeterSubmission._startLoginCheck()
                }
            });
        });
    }

    /**
     * @private
     */
    static _bindSubmit() {
        new SingleExecutionHandler(this._buttonSubmit, 'click', async () => {
            const requiredFields = [ 'datenschutz' ];

            const continueExecution = await this._$.post('ajax/wvll/ajax.php', {
                action:      'validateSendInput',
                privacy:     this._inputPrivacy.prop('checked'),
                ablesekarte: this._inputAblesekarte.prop('checked'),
                rechnung:    this._inputRechnung.prop('checked'),
                kopie:       this._inputKopie.prop('checked')
            }).then(JSON.parse).then(response => {
                if (response.error) {
                    this._containerError.html(response.response).show();

                    // client tried to send data a second time
                    if (!response.fields) {
                        this._tabInfoButton.tab('show');
                        return;
                    }

                    for (const name of response.fields) {
                        this._$(`input[name=${name}]`).removeClass('is-valid').addClass('is-invalid');
                    }

                    for (const name of requiredFields.filter(val => !response.fields.includes(val))) {
                        this._$(`input[name=${name}]`).removeClass('is-invalid').addClass('is-valid');
                    }
                } else {
                    this._containerError.html(response.response).show();

                    for (const name of requiredFields) {
                        this._$(`input[name=${name}]`).removeClass('is-invalid').addClass('is-valid');
                    }
                }

                return !response.error;
            });

            if (!continueExecution) {
                return;
            }

            return this._$.post('ajax/wvll/ajax.php', {
                action: 'send'
            }).then(JSON.parse).then(response => {
                if (!response.error) {
                    this._stopLoginCheck();

                    this._containerError.html(response.response).show();
                    this._tabSubmissionButton.addClass('disabled');
                }
            });
        });
    }

    /**
     * @param {String} username
     * @param {String} password
     * @private
     */
    static async _login(username, password) {
        return this._$.post('ajax/wvll/ajax.php', {
            action: 'login',
            ident:  username,
            pass:   password,
            qrcode: this.qrcode
        }).then(JSON.parse).then(response => {
            if (!response.error) {
                this.qrcode = false;

                if (response.skipSubmission) {
                    this._containerComplete.html(response.response);
                    this._tabCompleteButton.removeClass('disabled').tab('show');

                    this._containerError = this._$('.errorContainer');
                    this._inputPrivacy   = this._$('input[name=datenschutz]');

                    this._startLoginCheck();

                    return;
                }

                this._containerSubmmission.html(response.response);
                this._tabSubmissionButton.removeClass('disabled').tab('show');

                this._containerError = this._$('.errorContainer');
                this._buttonContinue = this._$('button[name=submissionContinue]');

                this._inputZaehler1    = this._$('input[name=zaehler1]');
                this._inputZaehler2    = this._$('input[name=zaehler2]');
                this._inputZaehler3    = this._$('input[name=zaehler3]');
                this._inputDatum       = this._$('input[name=datum]');
                this._inputTelefon     = this._$('input[name=tel]');
                this._inputEMail       = this._$('input[name=email]');
                this._inputBemerkungen = this._$('textarea[name=bemerkungen]');

                this._startLoginCheck();
                this._bindContinue();
            } else {
                this._containerError.html(response.response).show();
            }
        });
    }
}
